import React from 'react'
// import MetalworkingMain from './MetalworkingMain/MetalworkingMain'
import MetalworkingMachiningCenters from './MetalworkingMachiningCenters/MetalworkingMachiningCenters'
import MetalworkingWaterjet from './MetalworkingWaterjet/MetalworkingWaterjet'
// import NewsPreview from '../../Modules/NewsBlock/NewsPreview'
import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'

const Index = () => {
  return (
    <div>
      <HeaderEngineering />
      {/*<MetalworkingMain />*/}
      <MetalworkingMachiningCenters />
      <MetalworkingWaterjet />
      {/*<NewsPreview />*/}
    </div>
  )
}

export default Index
